import { FormModeConfig, FormModeDefaults } from '../../../base/interfaces/formModes.ts'
import { TransferenciaInputProps } from '../interfaces'

export type TransferenciaFormMode = 'rapid' | 'create' | 'edit' | 'consult'

/**
 * Configuración general de los modos del formulario
 */
export const transferenciaFormModeDefault: FormModeDefaults<TransferenciaFormMode> = {
  rapid: { disabled: false },
  create: { disabled: false },
  edit: { disabled: false },
  consult: { disabled: true },
}

export const transferenciaFormModelConfig: FormModeConfig<TransferenciaInputProps, TransferenciaFormMode> = {
  sucursalOrigen: {
    rapid: { disabled: true },
    create: { disabled: true },
    edit: { disabled: true },
    consult: { disabled: true },
  },

  sucursalDestino: {
    rapid: { disabled: false },
    consult: { disabled: true },
  },

  descripcionMovimiento: {
    rapid: { disabled: false },
    create: { disabled: false },
    edit: { disabled: false },
    consult: { disabled: true },
  },

  descuentoAdicional: {
    rapid: { disabled: false },
    create: { disabled: false },
    consult: { disabled: true },
  },

  moneda: {
    rapid: { disabled: false },
    create: { disabled: false },
    consult: { disabled: true },
  },

  tipoCambio: {
    rapid: { disabled: false },
    create: { disabled: false },
    consult: { disabled: true },
  },

  detalleExtra: {
    rapid: { disabled: false },
    create: { disabled: false },
    consult: { disabled: true },
  },

  nota: {
    rapid: { disabled: false },
    create: { disabled: false },
    consult: { disabled: true },
  },

  terminos: {
    rapid: { disabled: false },
    create: { disabled: false },
    consult: { disabled: true },
  },

  detalle: {
    rapid: { disabled: false },
    create: { disabled: false },
    consult: { disabled: true },
  },
}
